// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3wD8g","header":"PatientBlock_header__2x4eL","label":"PatientBlock_label__YD1sC","option":"PatientBlock_option__1ZWjR"};